import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import NotFound from './components/NotFound'

import Accueil from './components/Accueil'
import Search from './components/Search'
import Users from './components/Users'
import Connexion from './components/Connexion'
import Article from './components/Article'
import ArticleOnly from './components/ArticleOnly'
import Contact from './components/Contact'
import Emploi from './components/Emploi'
import Histoire from './components/Histoire'
import ConseilAdmin from './components/ConseilAdmin'
import Politique from './components/Politique'
import Informations from './components/Informations'
import CoursEnfant from './components/CoursEnfant'
import CoursAdulte from './components/CoursAdulte'
import MaitreNageur from './components/MaitreNageur'
import Synchro from './components/Synchro'
import Natation from './components/Natation'
import SauveSport from './components/SauveSport'
import CompetResult from './components/CompetResult'
import CampEte from './components/CampEte'
import CampHiver from './components/CampHiver'
import Sauvetage from './components/Sauvetage'
import Requalification from './components/Requalification'

import CAPN from './components/CAPN'
import Cours from './components/Cours'
import Competition from './components/Competition'
import Camp from './components/Camp'
import Formation from './components/Formation'


import * as serviceWorker from './serviceWorker'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';


import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom'

const Root = () => (
  <Router>
    <Switch>
      <Route exact path='/' component={Accueil} />
      <Route exact path='/articles' component={Article} />
      <Route exact path='/recherche/:search' component={Search} />
      <Route exact path='/contact' component={Contact} />
      <Route exact path='/CAPN/emploi' component={Emploi} />
      <Route exact path='/CAPN/histoire' component={Histoire} />
      <Route exact path='/CAPN/conseil-administration' component={ConseilAdmin} />
      <Route exact path='/CAPN/politiques' component={Politique} />
      <Route exact path='/CAPN/informations' component={Informations} />
      <Route exact path='/cours/enfants' component={CoursEnfant} />
      <Route exact path='/cours/adultes' component={CoursAdulte} />
      <Route exact path='/competiton/maitres-nageurs' component={MaitreNageur} />
      <Route exact path='/competiton/nage-synchronisee' component={Synchro} />
      <Route exact path='/competiton/natation' component={Natation} />
      <Route exact path='/competiton/sauvetage-sportif' component={SauveSport} />
      <Route exact path='/competiton/resultats' component={CompetResult} />
      <Route exact path='/camp/ete' component={CampEte} />
      <Route exact path='/camp/hiver' component={CampHiver} />
      <Route exact path='/formation/sauvetage' component={Sauvetage} />
      <Route exact path='/formation/requalification' component={Requalification} />

      <Route exact path='/CAPN' component={CAPN} />
      <Route exact path='/cours' component={Cours} />
      <Route exact path='/competiton' component={Competition} />
      <Route exact path='/camp' component={Camp} />
      <Route exact path='/formation' component={Formation} />

      <Route exact path='/articles/:nomArticle' component={ArticleOnly} />
      <Route exact path='/adminCreationContent' component={Connexion} />
      <Route path='/adminCreationContent/:pseudo' component={App} />
      <Route exact path='/users/:pseudo' component={Users} />
      <Route component={NotFound} />
    </Switch>
  </Router>
)

ReactDOM.render(<Root />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
